/** Checkbox column component for TanStack Table v8 row selection. */
import React from "react";
import { Checkbox, CheckboxProps } from "@mui/material";
import { createColumnHelper, ColumnDef } from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();

/**
 * Checkbox column definition for row selection.
 * Add as first column in table to enable "select all" functionality.
 */
export const checkboxColumn: ColumnDef<any, any> = columnHelper.display({
  id: "select",
  header: ({ table }) => (
    <Checkbox
      checked={table.getIsAllPageRowsSelected()}
      indeterminate={table.getIsSomePageRowsSelected()}
      onChange={(e) => {
        table.getToggleAllPageRowsSelectedHandler()(e);
      }}
      sx={{
        padding: 0,
        "&.Mui-checked": {
          color: "primary.main",
        },
      }}
    />
  ),
  cell: ({ row }) => (
    <Checkbox
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onChange={(e) => {
        row.getToggleSelectedHandler()(e);
      }}
      sx={{
        padding: 0,
        "&.Mui-checked": {
          color: "primary.main",
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
      }}
    />
  ),
  enableSorting: false,
  enableHiding: false,
});

export default checkboxColumn;
